export var ObSessionServiceErrors;

(function (ObSessionServiceErrors) {
  ObSessionServiceErrors["MISSING_SERVICE_URL"] = "The url for session service was not provided";
  ObSessionServiceErrors["MISSING_CAS_URL"] = "The url for CAS service was not provided";
  ObSessionServiceErrors["UNABLE_TO_INITIALIZE"] = "Unable to initialize session with OpenBet";
  ObSessionServiceErrors["UNABLE_TO_DESTROY_SESSION"] = "Unable to destroy session with OpenBet";
})(ObSessionServiceErrors || (ObSessionServiceErrors = {}));
//# sourceMappingURL=enums.js.map